export const BLOG_LIST_1_CONSTANTS = {
  BLOG_LIST_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Section title",
      value: "Blogs",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Section heading",
      required: false,
      defaultValue: "Blogs",
    },
    {
      fieldName: "title_color",
      label: "Title color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#000000",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "description",
      label: "Description",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Short intro under the title",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "description_color",
      label: "Description color",
      value: "#555555",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#555555",
      required: false,
      defaultValue: "#555555",
    },
    {
      fieldName: "section_background_color",
      label: "Section background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "category_title_color",
      label: "Category label color",
      value: "#374151",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#374151",
      required: false,
      defaultValue: "#374151",
    },
    {
      fieldName: "category_active_background_color",
      label: "Active category background",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#BE2330",
      required: false,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "category_carousel_left_arrow_url",
      label: "Category strip — left arrow image (optional)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      accept: "image/png,image/jpeg,image/webp,image/gif,image/svg+xml",
      wrapperClassName: "min-w-0 w-full max-w-full mb-4",
      placeholder: "Leave empty for default chevron tinted active color",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "category_carousel_right_arrow_url",
      label: "Category strip — right arrow image (optional)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      accept: "image/png,image/jpeg,image/webp,image/gif,image/svg+xml",
      wrapperClassName: "min-w-0 w-full max-w-full mb-4",
      placeholder: "Leave empty for default chevron tinted active color",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "date_calendar_icon_url",
      label: "Blog card date — calendar icon (optional)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      accept: "image/png,image/jpeg,image/webp,image/gif,image/svg+xml",
      wrapperClassName: "min-w-0 w-full max-w-full mb-4",
      placeholder: "Upload icon; leave empty for default (Figma solar calendar outline)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "date_icon_color",
      label: "Blog card date — icon color (default icon only)",
      value: "#373737",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#373737",
      required: false,
      defaultValue: "#373737",
    },
    {
      fieldName: "date_text_color",
      label: "Blog card date — text color",
      value: "#373737",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#373737",
      required: false,
      defaultValue: "#373737",
    },
    {
      fieldName: "card_title_color",
      label: "Blog card — title color",
      value: "#101112",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#101112",
      required: false,
      defaultValue: "#101112",
    },
    {
      fieldName: "card_description_color",
      label: "Blog card — description color",
      value: "#101112",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#101112",
      required: false,
      defaultValue: "#101112",
    },
    {
      fieldName: "read_more_label",
      label: "Read more label",
      value: "Read More",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Read More",
      required: false,
      defaultValue: "Read More",
    },
    {
      fieldName: "read_more_text_color",
      label: "Read more link color (cards)",
      value: "#60050e",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#60050e",
      required: false,
      defaultValue: "#60050e",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable section",
      defaultValue: false,
    },
  ],
};
